// Shared Mapbox style URLs — used by both MapboxMap and NoteLocationMap
export const MAP_STYLES = {
  light: "mapbox://styles/happyndikumana/cmbaw4nub000i01re02es6tgz",
  dark: "mapbox://styles/happyndikumana/cmhtzin4j00cq01ssecz016o3",
};
